// @flow
export { default } from './EventPlaceholder';



// WEBPACK FOOTER //
// ./src/components/event/EventPlaceholder/index.js